import React from "react";
import LeaderBoardCard from "./leaderboard-card";
import "./leaderboard-card.css";

export default function LeaderBoardCardWrapper({ projectList = [] }) {
  console.log(projectList);
  return (
    <div className="mt-3">
      {projectList?.map((content, _idx) => {
        return (
          <LeaderBoardCard
            content={content?.users}
            rank={_idx + 1}
            projectName={content?.projectName || ""}
            collegeName={content?.collegeName || ""}
          />
        );
      })}
    </div>
  );
}
